import { motion } from "framer-motion";

const Section = ({ children, className = "", id }) => (
  <motion.section
    id={id}
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.6 }}
    className={`py-20 md:py-28 ${className}`}
  >
    <div className="container mx-auto px-4">{children}</div>
  </motion.section>
);

export default Section;
